import React from 'react';
import { PictoProps } from './index';

export const ArrowUp = (props: PictoProps) => (
  <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 0L6.9641 6H0.0358984L3.5 0Z" {...props} />
  </svg>
);
